export default __webpack_public_path__ + "static/media/plague.a21ef1a9.webp";